export const isValidEmail = (value) => {
  if (typeof value !== 'string') {
    return false;
  }

  const email = value.trim();

  if (!email || email.length > 254 || email.includes(' ')) {
    return false;
  }

  const parts = email.split('@');
  if (parts.length !== 2) {
    return false;
  }

  const [localPart, domain] = parts;

  if (!localPart || !domain || localPart.length > 64) {
    return false;
  }

  if (localPart.startsWith('.') || localPart.endsWith('.') || localPart.includes('..')) {
    return false;
  }

  if (!/^[A-Za-z0-9.!#$%&'*+/=?^_`{|}~-]+$/.test(localPart)) {
    return false;
  }

  const domainLabels = domain.split('.');
  if (domainLabels.length < 2 || domain.endsWith('.') || domain.includes('..')) {
    return false;
  }

  return domainLabels.every((label) => {
    if (!label || label.length > 63) {
      return false;
    }

    if (label.startsWith('-') || label.endsWith('-')) {
      return false;
    }

    return /^[A-Za-z0-9-]+$/.test(label);
  });
};

export default isValidEmail;